const handleCancelActionFormActions = {
  confirm: 'Deseja realmente cancelar essa ação?',
  title: 'CANCELAR AÇÃO',
  newStatus: 'Cancelado'
};

export default handleCancelActionFormActions;
